export const INVALID_ARGUMENTS = {type: 'Invalid Arguments'};

/**
 * A symbol to use in Objects for custom data types that don't exist in plain Javascript.
 */
export const TYPE = Symbol.for('$type');
